import type { CSSProperties } from 'react';

export const gridContainerBaseStyle = (
  height?: string,
  maxHeight?: string,
  scrollY = false
): CSSProperties & Record<string, string> => ({
  width: '100%',
  overflowX: 'hidden',
  ...(scrollY ? { overflowY: 'auto' } : {}),
  '--ag-header-border-color': 'transparent',
  '--ag-header-row-border': 'none',
  '--ag-header-column-separator-color': 'transparent',
  '--ag-header-column-separator-width': '0px',
  ...(height ? { height } : {}),
  ...(maxHeight ? { maxHeight } : {}),
});

export const splitLayoutStyle: CSSProperties = {
  display: 'flex',
  gap: '16px',
  width: '100%',
};

export const mainContentStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  flex: 1,
  minWidth: 0,
};

export const actionBarStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '16px',
};

export const actionBarLeftStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
};

export const actionBarRightStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
};
